module.exports = __webpack_public_path__ + "static/media/sun.8321adf4.svg";